function init() {
  const actions = window.Shopify?.actions;
  if (!actions) return;
  actions.updateCart.configure({
    eventTarget: () => document.querySelector("theme-drawer#cart-drawer") ?? document
  });
  actions.openCart.configure({
    async handler() {
      const drawer = document.querySelector("theme-drawer#cart-drawer");
      if (drawer) {
        document.dispatchEvent(new CustomEvent("hb:bag:open"));
      } else {
        window.location.href = Theme.routes.cart_url || "/cart";
      }
    }
  });
}

if (window.Shopify?.actions) {
  init();
} else {
  document.addEventListener("DOMContentLoaded", init, {
    once: true
  });
}